module.exports = __webpack_public_path__ + "static/img/play-intro-img-3.28d9606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-intro-img-3.png
// module id = A8KQ
// module chunks = 2 3